import {combineReducers} from 'redux';

import {ingestReport} from '@pluto/ingest-validation-report';
import {ingestStatuses} from '@pluto/ingest-status';
import initialValuesForEditingIngestConfig from '../../Ingest/IngestConfigItem/EditingIngestConfig/Redux/EditingIngestConfigReducer';
import ingestConfigs from '../../Ingest/IngestConfigs/Redux/IngestConfigsReducer';
import ingestData from '../../Ingest/IngestData/Redux/IngestDataReducer';
import ingestList from '../../Ingest/IngestList/Redux/IngestListReducer';

const ingestStore = combineReducers({
    ingestStatuses,
    ingestList,
    ingestReport,
    ingestData,
    ingestConfigs,
    initialValuesForEditingIngestConfig,
});

export default ingestStore;
